import api from '../api';
import { JSEncrypt } from 'jsencrypt';

const Utils = {};
Utils.uniqObjInArray = function(objarray) {
    let len = objarray.length;
    let tempJson = {
    
    };
    let res = [];
    for(let i = 0;i < len;i++){
        //取出每一个对象
        tempJson[JSON.stringify(objarray[i])] = true;
    }
    let keyItems= Object.keys(tempJson);
    for(let j = 0;j < keyItems.length;j++){
        res.push(JSON.parse(keyItems[j]));
    }
    return res;
}
Utils.IMGPATHROOT_SHRIK = api.imageSrcPrefixThumbnails;
Utils.IMGPATHROOT = api.imageSrcPrefix;
Utils.dealDiseaseName = function(obj,allDisease) {
    if(obj.hasOwnProperty('children')) {
        let c = obj.children;
        for(let i = 0; i < c.length; i++) {
            c[i].name = c[i].name.replace(/^[0-9]+-/,"");
            this.dealDiseaseName(c[i],allDisease);
        }
      } else {
            obj.name = obj.name.replace(/^[0-9]+-/,"");
            if(obj.name !== "其他") {
            let j = {};
            j.value = obj.name;
            j.id = obj.id;
            allDisease.push(j);
        }
    }
}
Utils.GENERAL = {
    code: 1,
    text: "大体图/伍德灯"
},
Utils.SOAK = {
    code: 2,
    text: "浸润皮肤镜图"
}
Utils.POLARRIZE = {
    code: 4,
    text: "偏振光皮肤镜图"
}
Utils.CT = {
    code: 8,
    text: "皮肤CT"
}
Utils.BC = {
    code: 16,
    text: "皮肤B超"
}
Utils.PATHOlOGY = {
    code: 32,
    text: "皮肤病理"
}

//  RSA公钥加密
Utils.rsaEncryptData = function(data) {
    // 新建JSEncrypt对象
    let encryptor = new JSEncrypt();
    // 设置公钥
    let publicKey = '-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgSajWypYc27WI8y5aZZ9BnYtUjKmaiLcSa3GTnpxIhFBJ3t4qMsRUw6G0C8qoRGQ31ASr4ghvQQZuRl37WFuJS0iSsIE9Tz1K4/Oof3jsVJ6dhzEajM8gy2ZWE4V5fAKmn6tTgIRb+SRXDpbbxYSb3c175vwC95WCvG3u6iZ1lvUaTpFYg/zHWMjs3AF+Uxy6V5QNN3f8vns98pRYAKzqLNnxnAIFsiX+Pfpwcgbd5D0q3rYimco0zce35DzscFamlLE6W2AH8A6TJ4WPzLVD7AgyXLyESw0aXrcPxqUvxLeTVgA3P6YbYLwJi9+QfDT6Ql/UWEN1LH5KSk+GDv8ywIDAQAB\n-----END PUBLIC KEY-----'
    encryptor.setPublicKey(publicKey);
    // 加密数据
    let code = encryptor.encrypt(data);
    // console.log("In utils, data after RSA Enc:",code);
    return code
}
Utils.getStorageRateMsg = function() {
      let accountInfo = this.$store.state.accountInfo;   
      console.log("In Utils, accountInfo:", accountInfo);
      if(accountInfo.space_allocated <= 0) return "";
      if(accountInfo.space_used && accountInfo.space_allocated){
        let rate = (accountInfo.space_used / accountInfo.space_allocated) * 100;
        if (rate < 80) return "";
        if (rate < 90) return "存储空间即将不足，建议尽快升级扩容！";
        return "存储空间严重不足，请尽快升级扩容！";
      }else{
        return ""
      }
}

export default  Utils;
